import React, { useRef, useEffect, useState } from 'react';

import { basePath } from '../../utils/contants/urlsApi';

import { QRCode } from 'react-qrcode-logo';

import Peer from 'peerjs';

import './signature.scss';

export const Signature = (props) => {


    //const singnatureRemote =  new Date().getTime();
    const signatureRemote =  'abc123';
    const canvas = useRef();
    let context;
    let isDraw = false;

    //const config = {id:'teste', 'iceServers': [{ 'url': 'stun:stun.l.google.com:19302' }] };
    const config = {'iceServers': [{ 'url': 'stun:stun.l.google.com:19302' }] };
    //const config = singnatureRemote;

    
    let peer = null;
    let conn = null;
    
    //peer = new Peer(singnatureRemote, config);
    peer = new Peer(signatureRemote);

    peer.on('open', id => {
        console.log('peer-id-', id);
        console.log('peer-id', peer.id);
    });

    peer.on('connection', c => {
        if(conn){
            c.on('open', () => {
                c.send('Client Connect. Connection close.');
                c.close();
            });
            return;
        }

        conn = c;
        
        conn.on('data', data => {
            console.log('data received');
            console.log('Menssage:', data);
            context = canvas.current.getContext('2d');
            const image = new Image();
            image.addEventListener('load', () => {
                const difX = (data.width  / canvas.current.width) * 0.5;
                const difY = 0;
                context.drawImage(image, difX, difY);
            });
            image.src = data.data;
        });

        conn.on('close', ()=>{
            console.log('Connection reset');
            conn = null;
        });

    });

    peer.on('disconnected', () => {
        console.log('disconnected');
        peer.reconnect();
    });

    peer.on('close', () => {
        console.log('Connection close. Destroyed.');
    });

    peer.on('close', err => {
        console.log('Error', err);
    });

    const send = message =>{
        if(conn && conn.open){
            conn.send(message);
        }else{
            console.log('Connection is close');
        }
    }

    const end = () =>{
        conn.close();
    }

    const setDraw = (e) => {
        isDraw = (/mousedown|touchstart/gi).test(e.type);
        if(isDraw){
            context = canvas.current.getContext('2d');
            const x  = Math.round((e.clientX || e.touches[0].clientX ) - canvas.current.getBoundingClientRect().left);
            const y  = Math.round((e.clientY  || e.touches[0].clientY) - canvas.current.getBoundingClientRect().top);
            context.moveTo(x, y);
            context.beginPath();
        }else{
            context.closePath();
        }
    }

    const clearCanvas = () => {
        context = canvas.current.getContext('2d');
        context.clearRect(0, 0, canvas.current.width, canvas.current.height);
    }   

    const draw = (e) => {
        const x  = Math.round((e.clientX || e.touches[0].clientX ) - canvas.current.getBoundingClientRect().left);
        const y  = Math.round((e.clientY  || e.touches[0].clientY) - canvas.current.getBoundingClientRect().top);
        if(isDraw){
            context = canvas.current.getContext('2d');
            context.lineTo(x, y);
            context.stroke();
        }

        //console.log(x, y);
        
    }

    useEffect(()=>{
        canvas.current.addEventListener('mousedown', setDraw);
        canvas.current.addEventListener('touchstart', setDraw);
        canvas.current.addEventListener('mouseup', setDraw);
        canvas.current.addEventListener('touchend', setDraw);
        canvas.current.addEventListener('mousemove', draw);
        canvas.current.addEventListener('touchmove', draw);

        const size = canvas.current.parentNode.getBoundingClientRect();
        canvas.current.width = size.width ;
        canvas.current.height = size.height;

        context = canvas.current.getContext('2d');
        context.lineWidth = 1;

    }, [signatureRemote]);

    return (
        <div className="signature-area">
            assinatura <button onClick={()=>{clearCanvas()}}>Limpar</button>
            <div className="area">
                <canvas ref={canvas}></canvas>
            </div>
            <div>
                {
                    signatureRemote ?
                        <QRCode value={`${window.location.host}/Signature/${signatureRemote}`} />
                    :
                    ''
                }
            </div>
        </div>
    )
}